export default "__VITE_PUBLIC_ASSET__6de83864__"